<ng-container *ngIf="activity$| async as activity; else loading">

<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
  <ion-toolbar mode="md">

    <ion-title class="ion-text-center header-title">{{ activity?.name | ppTranslate:activity?.nameTranslations:translateService.currentLang }}</ion-title>

    <!--<ion-buttons slot="start" class="header-buttons">
      <ion-back-button color="secondary" defaultHref="../../"></ion-back-button>
    </ion-buttons>-->

    <!--(click)="navigateToServicePick()" -->

    <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
     
      <ion-button *ngIf="!activity.zajla && !activity.vip && !activity.taggenbrunn" [routerLink]="'/kulinaricne-delavnice'" class="header-buttons__btn">
        <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
      </ion-button>

      <ion-button *ngIf="activity.zajla" [routerLink]="'/vecerja-na-zajli'" class="header-buttons__btn">
        <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
      </ion-button>

      <ion-button *ngIf="activity.vip" [routerLink]="'/vip-gourmet-klub'" class="header-buttons__btn">
        <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
      </ion-button>

      <ion-button *ngIf="activity.taggenbrunn" [routerLink]="'/taggenbrunn'" class="header-buttons__btn"> 
        <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
      </ion-button>

    </ion-buttons>

    <app-top-right slot="end"></app-top-right>

  </ion-toolbar>
  </ion-grid>
</ion-header>

<!--ion-progress-bar style="height: 2px; margin-bottom: 20px;" color="secondary" value=".60" buffer="1"></ion-progress-bar-->


<ion-content [style.border-color]="'#0100ee'" style="border-top:4px solid #0100ee;" min="0" max="2400" color="white" class="ion-padding profile">
  <ion-grid fixed class="ion-no-padding">
  
  <div class="ion-padding profile__picture" *ngIf="activity?.avatar?.document?.fileName">
    <img *ngIf="activity?.avatar?.document?.fileName" [src]="activity?.avatar?.document?.fileName | ppImage">
  </div>


  <div class="ion-padding profile__info" style="padding-bottom:0px; ">


    <h5 *ngIf="!activity.zajla && !activity.vip && !activity.taggenbrunn">Kulinarična delavnica</h5>
    <h5 *ngIf="activity.zajla">Kulinarično doživetje</h5>
    <h5 *ngIf="activity.vip">Kulinarični dogodek</h5>
    <h5 *ngIf="activity.taggenbrunn">{{ 'EXPERIENCE.TAGGENBRUNN.EVENT' | translate }}</h5>
    <h1 style="margin-top:15px;">{{ activity?.name | ppTranslate:activity?.nameTranslations:translateService.currentLang }}</h1>
    <p *ngIf="!activity.zajla && !activity.vip && !activity.taggenbrunn">Akademija Jezeršek, {{activity?.events[0]?.location?.address}}</p>
    <p *ngIf="activity.zajla">RTC Krvavec, Grad 76, 4207 Cerklje na Gorenjskem</p>
    <p *ngIf="activity.vip">{{activity?.events[0]?.venueText}}</p>
    <p *ngIf="activity.taggenbrunn">{{ 'EXPERIENCE.TAGGENBRUNN.ADDRESS' | translate }}</p>
    <img style="margin-top:10px; height:15px" *ngIf="activity.difficulty" [src]="'/assets/icons/' + activity.difficulty + '.gif'" />
    <br/>
    

    <!--h2>{{ service.shortDescription | ppTranslate:service.longDescriptionTranslations:translateService.currentLang }}</h2-->
    <p *ngIf="activity.longDescription" class="" innerHtml="{{ activity?.longDescription | ppTranslate:activity?.longDescriptionTranslations:translateService.currentLang }}"></p>

  </div>

<ion-grid class="ion-padding">
  
  <h3 class="" style="margin-bottom: 15px; margin-top:25px;"><b>{{ 'EXPERIENCE.ANNOUNCED_SLOTS' | translate }}:</b></h3>

  <ng-container  *ngFor="let event of activity.events">
  <ion-item lines="full" class="event-item" *ngIf="event.start > nowStr && event.status >= 20 && event.status <= 40">
    <ion-grid >
      <!-- Large screens: horizontal layout -->
      <ion-row class="ion-align-items-center ion-hide-lg-down">
        <ion-col size="3">
          <!--ion-icon name="calendar-outline" class="icon-inline"></ion-icon-->
          <b>{{ event.start | date:'EEEE': undefined: translateService?.currentLang }},
          {{ event.start | date:'mediumDate': undefined: translateService?.currentLang }}</b>
        </ion-col>

        <ion-col size="3">
          <ion-icon name="time-outline" class="icon-inline"></ion-icon>
          {{ event.start | date:'H:mm' : undefined: translateService?.currentLang }} -
          {{ event.end | date:'H:mm' : undefined: translateService?.currentLang }}
        </ion-col>

        <ion-col size="3">
          <ion-icon name="card-outline" class="icon-inline"></ion-icon>
          {{ event.regularPrice1 | currency: 'EUR': 'symbol': '1.2-2' }}
        </ion-col>

        <ion-col size="3"><!--routerLink]="['./', event.id, 'prijava']"  -->
        
          <!--ion-button  *ngIf="activity.zajla && event.spots >= 1" class="medium-button" [expand="block" [routerLink]="['./', event.id, 'prijava']">Prijava</ion-button>

          <ion-button  color="light" *ngIf="activity.zajla && event.spots < 1" class="medium-button" (click)="openOfferInfoModal( event )" [expand="block">Razprodano</ion-button-->
          
          <ion-button   *ngIf="event.spots >= 1" class="medium-button" [routerLink]="['./', event.id, 'prijava']" expand="block">{{ 'EXPERIENCE.SIGN_UP_BTN' | translate }}</ion-button>
          
          <ion-button  color="medium" fill="clear" *ngIf="event.spots < 1" class="medium-button" (click)="openOfferInfoModal( event )"   expand="block">{{ 'EXPERIENCE.SOLD_OUT_BTN' | translate }}</ion-button>
        
        </ion-col>
      </ion-row>

      <!-- Small & Medium screens: vertical stacked layout -->
      <ion-row class="ion-hide-lg-up vertical-layout">
        <ion-col size="12" class="event-line">
          <!--ion-icon name="calendar-outline" class="icon-inline"></ion-icon-->
          <h5><b>{{ event.start | date:'EEEE': undefined: translateService?.currentLang }},
          {{ event.start | date:'mediumDate': undefined: translateService?.currentLang }}</b></h5>
        </ion-col>

        <ion-col size="12" class="event-line">
          <ion-icon name="time-outline" class="icon-inline"></ion-icon>
          {{ event.start | date:'H:mm' : undefined: translateService?.currentLang }} -
          {{ event.end | date:'H:mm' : undefined: translateService?.currentLang }}
        </ion-col>

        <ion-col size="12" class="event-line">
          <ion-icon name="card-outline" class="icon-inline"></ion-icon>
          {{ event.regularPrice1 | currency: 'EUR': 'symbol': '1.2-2' }}
        </ion-col>

        <ion-col size="12">
          <ion-button *ngIf="event.spots >= 1" class="medium-button" [routerLink]="['./', event.id, 'prijava']"  expand="block">{{ 'EXPERIENCE.SIGN_UP_BTN' | translate }}</ion-button> <!--[routerLink]="['./', event.id, 'prijava']"-->
          <ion-button *ngIf="event.spots < 1" color="medium" fill="clear" class="medium-button" (click)="openOfferInfoModal( event )"  expand="block">{{ 'EXPERIENCE.SOLD_OUT_BTN' | translate }}</ion-button> <!--[routerLink]="['./', event.id, 'prijava']"-->
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-item>
  </ng-container>
</ion-grid>


   
    <!--ion-row>
      
      <ion-col>12.2.2025 </ion-col>
      <ion-col>12:00 - 17:00</ion-col>
      <ion-col>88,20€</ion-col>
      <ion-col><ion-button style="font-size: 13px;" color="primary">Rezerviraj</ion-button></ion-col>

    </ion-row-->


  <!--div class="ion-float-right clickable" color="primary" style="margin-top:20px;">
    Za rezervacijo pišite na <a href="mailto:akademija@jezersek.si">akademija@jezersek.si</a>
    <ion-button style="font-size: 13px;" class="ion-float-right" color="primary"></ion-button>
  </div-->

  
  </ion-grid>
</ion-content>

<!--ion-content >
  <ion-grid fixed class="ion-no-padding">



  </ion-grid>
</ion-content-->

</ng-container>

  <!--app-stepper [currentStep]="2"></app-stepper-->

  <!--ion-grid class="ion-no-padding stepper" style="padding-bottom:10px;" *ngIf="'restavracija-strelec' !== real?.slug && 'jaz-by-me' !== real?.slug" >
    <ion-row  class="ion-no-padding">
      <ion-col class="ion-no-padding" size="4">
        <ion-button (click)="navigateToServicePick()" color="light" mode="ios" class="btn--small stepper__btn ion-no-padding ion-no-margin" expand="full"
        disabled="false">
          <div>{{ 'PICK_SLOT.HOME' | translate }}</div>
        </ion-button>
      </ion-col>

      <ion-col class="ion-no-padding" size="4">
        <ion-button  color="secondary" mode="ios" class="btn--small stepper__btn--active ion-no-padding ion-no-margin"
        expand="full" disabled="false">
          <div>{{ 'PICK_SLOT.PICK_SLOT' | translate }}</div>
        </ion-button>
      </ion-col>

      <ion-col class="ion-no-padding" size="4">
        <ion-button [routerLink]="['../../../../predogled']" color="light" mode="ios" class="btn--small stepper__btn ion-no-padding ion-no-margin" expand="full"
        [disabled]="!pick?.isCombinationPicked()" >
          <div>{{ 'PICK_SLOT.PREVIEW' | translate }}</div>
        </ion-button>
      </ion-col>

    </ion-row>
  </ion-grid-->

  <!--ion-list style="padding-bottom:0px; padding-top:0px; background-color: white; position: sticky; top: 0; left: 0; right: 0; z-index: 9999;"  >

  <ion-item  style="background-color: white; z-index: 999;">

    <span slot="end" style="color:#11324D">{{ 'PICK_SLOT.TABLE_FOR' | translate }}</span>

    <ion-select #mySelect  slot="end" style="margin-left: 10px; margin-right: -10px; padding-right: 15px; color: white; font-weight: bold;" [style.background-color]="('restavracija-strelec' !== real?.slug && 'jaz-by-me' !== real?.slug)?'#0100ee':'#C1CfC0'" *ngIf="pick?.partySize" interface="popover" [(ngModel)]="pick.partySize" (ionChange)="onPartySizeChange($event)" placeholder="Število oseb">
      
      <ion-select-option [value]="1">1 {{ 'PICK_SLOT.PERSON_1' | translate }}</ion-select-option>
      <ion-select-option [value]="2">2 {{ 'PICK_SLOT.PERSONS_2' | translate }}</ion-select-option>
      <ion-select-option [value]="3">3 {{ 'PICK_SLOT.PERSONS_3' | translate }}</ion-select-option>
      <ion-select-option [value]="4">4 {{ 'PICK_SLOT.PERSONS_4' | translate }}</ion-select-option>
      <ion-select-option [value]="5">5 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>


      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 6 )" [value]="6"><span *ngIf="real.confirmationNeededPartySize && real.confirmationNeededPartySize <= 6">{{ 'PICK_SLOT.GROUP' | translate }} </span>6 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 7 )" [value]="7"><span *ngIf="real.confirmationNeededPartySize && real.confirmationNeededPartySize <= 7">{{ 'PICK_SLOT.GROUP' | translate }} </span>7 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 8 )" [value]="8"><span *ngIf="real.confirmationNeededPartySize && real.confirmationNeededPartySize <= 8">{{ 'PICK_SLOT.GROUP' | translate }} </span>8 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 9 ) && 'jaz-by-me' !== real?.slug" [value]="9"><span *ngIf="real.confirmationNeededPartySize && real.confirmationNeededPartySize <= 9">{{ 'PICK_SLOT.GROUP' | translate }} </span>9 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 10 ) && 'jaz-by-me' !== real?.slug" [value]="10"><span *ngIf="real.confirmationNeededPartySize && real.confirmationNeededPartySize <= 10">{{ 'PICK_SLOT.GROUP' | translate }} </span>10 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 11 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="11"><span *ngIf="real.confirmationNeededPartySize && real.confirmationNeededPartySize <= 11">{{ 'PICK_SLOT.GROUP' | translate }} </span>11 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 12 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="12"><span *ngIf="real.confirmationNeededPartySize && real.confirmationNeededPartySize <= 12">{{ 'PICK_SLOT.GROUP' | translate }} </span>12 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 13 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="13">{{ 'PICK_SLOT.GROUP' | translate }} 13 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 14 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="14">{{ 'PICK_SLOT.GROUP' | translate }} 14 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 15 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug"[value]="15">{{ 'PICK_SLOT.GROUP' | translate }} 15 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 16 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="16">{{ 'PICK_SLOT.GROUP' | translate }} 16 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 18 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="18">{{ 'PICK_SLOT.GROUP' | translate }} 18 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 19 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="19">{{ 'PICK_SLOT.GROUP' | translate }} 19 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 20 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="20">{{ 'PICK_SLOT.GROUP' | translate }} 20 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 21 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="21">{{ 'PICK_SLOT.GROUP' | translate }} 21 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 22 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="22">{{ 'PICK_SLOT.GROUP' | translate }} 22 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 23 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="23">{{ 'PICK_SLOT.GROUP' | translate }} 23 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 24 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="24">{{ 'PICK_SLOT.GROUP' | translate }} 24 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 25 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="25">{{ 'PICK_SLOT.GROUP' | translate }} 25 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 30 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="30">{{ 'PICK_SLOT.GROUP' | translate }} 30 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
       <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 35 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug" [value]="35">{{ 'PICK_SLOT.GROUP' | translate }} 35 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 40 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug && 'city-terasa-maribor' !== real?.slug" [value]="40">{{ 'PICK_SLOT.GROUP' | translate }} 40 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>
      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 50 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug && 'city-terasa-maribor' !== real?.slug" [value]="50">{{ 'PICK_SLOT.GROUP' | translate }} 50 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>

      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 60 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug && 'city-terasa-maribor' !== real?.slug" [value]="60">{{ 'PICK_SLOT.GROUP' | translate }} 60 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>

      <ion-select-option *ngIf="( !real.contactUsPartySize || real.contactUsPartySize > 70 ) && real.confirmationNeededPartySize && 'jaz-by-me' !== real?.slug && 'city-terasa-maribor' !== real?.slug" [value]="70">{{ 'PICK_SLOT.GROUP' | translate }} 70 {{ 'PICK_SLOT.PERSONS_5' | translate }}</ion-select-option>

      <ion-select-option *ngIf="real.contactUsPartySize" [value]="999">{{ 'PICK_SLOT.XL_GROUP' | translate }}</ion-select-option>

    </ion-select>

  </ion-item>


</ion-list-->


<ng-template #loading>
  <ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
  <ion-toolbar mode="md">

    <ion-title class="ion-text-center header-title"></ion-title>

    <!--<ion-buttons slot="start" class="header-buttons">
      <ion-back-button color="secondary" defaultHref="../../"></ion-back-button>
    </ion-buttons>-->

    <!--(click)="navigateToServicePick()" -->

    <ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
      <ion-button [routerLink]="'/kulinaricne-delavnice'" class="header-buttons__btn">
        <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
      </ion-button>
    </ion-buttons>

    <app-top-right slot="end"></app-top-right>

  </ion-toolbar>
  </ion-grid>
</ion-header>
  <ion-content class="ion-padding">
    <ion-grid fixed>
      <!-- Skeleton for title -->
      <ion-skeleton-text animated style="width: 60%; height: 32px; margin-bottom: 12px;"></ion-skeleton-text>
      
      <!-- Skeleton for avatar -->
      <ion-skeleton-text animated style="width: 100%; height: 200px; margin-bottom: 16px;"></ion-skeleton-text>
      
      <!-- Skeleton lines for text -->
      <ion-skeleton-text animated style="width: 90%; height: 16px; margin-bottom: 8px;"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 80%; height: 16px; margin-bottom: 8px;"></ion-skeleton-text>
      <ion-skeleton-text animated style="width: 70%; height: 16px; margin-bottom: 8px;"></ion-skeleton-text>

      <!-- Skeleton list items -->
      <ion-item *ngFor="let i of [1,2,3]" lines="full">
        <ion-label>
          <ion-skeleton-text animated style="width: 60%; height: 16px;"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 40%; height: 16px; margin-top: 6px;"></ion-skeleton-text>
        </ion-label>
        <ion-button fill="clear" slot="end" disabled>
          <ion-skeleton-text animated style="width: 60px; height: 32px;"></ion-skeleton-text>
        </ion-button>
      </ion-item>
    </ion-grid>
  </ion-content>
</ng-template>